// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData, deleteTransactionData, mergeTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminEvaluationApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/evaluation";

    // API実行, asset_type, file ,file_name
    const ExecAdminEvaluationApi = async (question, predicted_answer) => {

        // 必要なリクエストを定義
        const requestParams = {
            question: question,
            predicted_answer: predicted_answer,
        };
    
        let response = null;
        let error = null;
        console.log(requestParams);
    
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url:url, requestParams:requestParams, timeout:10*60*1000 });
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
        }
        return { response, error };
    };

    return ExecAdminEvaluationApi;
};

export default AdminEvaluationApi;